import blog_thumbnail_1 from '../../assets/images/blog/blog-thumbnail-1.jpg';
import blog_thumbnail_2 from '../../assets/images/blog/blog-thumbnail-2.jpg';
import blog_thumbnail_3 from '../../assets/images/blog/blog-thumbnail-3.jpg';
import blog_thumbnail_4 from '../../assets/images/blog/blog-thumbnail-4.jpg';
import blog_thumbnail_5 from '../../assets/images/blog/blog-thumbnail-5.jpg';
import blog_thumbnail_6 from '../../assets/images/blog/blog-thumbnail-6.jpg';
import blog_thumbnail_7 from '../../assets/images/blog/blog-thumbnail-7.jpg';
import blog_thumbnail_8 from '../../assets/images/blog/blog-thumbnail-8.jpg';
import blog_thumbnail_9 from '../../assets/images/blog/blog-thumbnail-9.jpg';
import blog_thumbnail_10 from '../../assets/images/blog/blog-thumbnail-10.jpg';
import blog_thumbnail_11 from '../../assets/images/blog/blog-thumbnail-11.jpg';
import blog_thumbnail_12 from '../../assets/images/blog/blog-thumbnail-12.jpg';

const blog = [
    {
        thumbnail: blog_thumbnail_1,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_2,
        title: 'Raving reviews about our latest algorithms.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_3,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_4,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_5,
        title: 'Raving reviews about our latest algorithms.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_6,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_7,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_8,
        title: 'Raving reviews about our latest algorithms.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_9,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_10,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_11,
        title: 'Raving reviews about our latest algorithms.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    },
    {
        thumbnail: blog_thumbnail_12,
        title: 'New features coming in 2020 to our app.',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: 'Behold creature him whose own does not god seasons winged two will not bearing herein fowl fruitful they went there beginning ... ',
        url: '/blog-detail-1',
    }
]

export default blog;